import React from 'react';
import SubjectPage from '../../Subjects/SubjectPage';

function Mnemonic() {

    const pageTitleText = "JEE Formula Sheet ";

  return (
    <>
    
      <SubjectPage 
        name={pageTitleText} 
        link="mnemonic" 
      />

    </>
  );
}

export default Mnemonic;